import React from "react";
import { Dropdown } from "@lwt-helix/dropdown";
import { viewTypes } from "../constants";
import { useSearchStore } from "../../store/search/store";

const ViewTypesSelector = () => {

    const {
        setSelectedViewTypeId,
        viewTypeId,
    } = useSearchStore(state => ({
        setSelectedViewTypeId: state.setSelectedViewTypeId,
        viewTypeId: state[state.selectedModule]?.viewTypeId
    }));

    const viewTypeOptions = [
        {
            dataLwtId: 'by-office-item',
            itemText: viewTypes.byOffice.label,
            key: viewTypes.byOffice.id,
            onClick: () => setSelectedViewTypeId(viewTypes.byOffice.id)
        },
        {
            dataLwtId: 'by-brokerage-item',
            itemText: viewTypes.byBrokerage.label,
            key: viewTypes.byBrokerage.id,
            onClick: () => setSelectedViewTypeId(viewTypes.byBrokerage.id)
        }
    ];

    return (
        <Dropdown
            dataLwtId="view-type-dropdown"
            items={viewTypeOptions}
            menuProps={{
                dataLwtId: 'share-menu',
                right: true
            }}
            toggleProps={{
                dataLwtId: 'no-split-toggle',
                id: 'caret',
                color: 'secondary',
                caret: true,
                children: viewTypeOptions.find((vt) => vt.key === viewTypeId)?.itemText,
                className: 'btn btn-sm btn-secondary mb-1 mr-2'
            }}
        />
    );
};

export default ViewTypesSelector;
